import $ from 'jquery';
import base64 from 'base-64';
import utf8 from 'utf8';

class GithubGate {
    constructor(opt){
        this.access_token = null;
        this.user_login = null;
        this.OAuth = opt.OAuth;
        this.authPoint = opt.authPoint;
        this.apiGate = opt.apiGate;
        this.org = opt.org;
        this.corpuses = opt.corpuses;
        this.client_id = this.OAuth.client_ids[opt.GithubAPP];
        
        $.ajaxSetup({ cache: false });
    }

    checkAuthorization(success, failure){
        var self = this;
        var accessToken = window.sessionStorage.getItem('access_token');
        if(accessToken){
            self.access_token = accessToken;
            this.getUser(success, failure);
        }
        else{
            failure();
        }
    }

    getOauthCode(){
        window.location = this.OAuth.point+'?client_id='+this.client_id+'&scope=repo&redirect_uri='+this.OAuth.redirectURI+'&response_type=code&state='+Math.random();
    }

    getAccessToken(code, state, success, failure){
        var self = this;
        var q = {
            'client_id': self.client_id,  
            'code': code,
            'redirect_uri': self.OAuth.redirectURI,
            'state': state,
            'grant_type': 'authorization_code'
        };

        $.ajax({
            type: "POST",
            dataType: "json",
            crossDomain: true,
            data: q,
            url: self.authPoint,
            success: function(response){
                self.access_token = response.access_token;
                window.sessionStorage.setItem('access_token', response.access_token);
                success();
            },
            error: self.getErrorDefaultCallback(failure)
        });
    }

    getUser(success, failure){
        var self = this;
        
        $.ajax({
            type: "GET",
            dataType: "json",
            crossDomain: true,
            headers: {
                "Authorization": "token "+self.access_token
            },                   
            url: self.apiGate+'/user',
            success: function(usr_response){
                $.ajax({
                    type: "GET",
                    dataType: "json",
                    crossDomain: true,
                    headers: {
                        "Authorization": "token "+self.access_token
                    },                   
                    url: self.apiGate+'/orgs/'+self.org+'/repos',
                    data: {
                        
                    },
                    success(repo_response){
                        var repos = {};
                        repo_response.map(repo => {
                            if(repo.permissions.push){
                                repos[repo.full_name] = {
                                    'canWriteMaster': repo.permissions.admin
                                };
                            }
                        });
                        var user = {
                            name: usr_response.name || usr_response.login, 
                            avatar: usr_response.avatar_url,
                            repos: repos
                        };
                        self.user_login = usr_response.login;
                        success(user);
                    },
                    error: self.getErrorDefaultCallback(failure)
                });
            },
            error: self.getErrorDefaultCallback(failure)
        });
    }

    search(corpus, keyword,callback, errorCallback){
        var self = this;
        keyword = keyword.trim();
        // Если поиск похож на поиск по коду, пробуем найти такую карточку
        if(/^[0-9-]+$/.test(keyword)){
            this.getCardVersion(
                corpus, 
                keyword, 
                null, 
                (data) => {
                    var strings = data.split("\n");
                    callback([{
                        code: keyword,
                        corpus: corpus,
                        header: strings[0]
                    }]);
                },
                errorCallback
            )
        }
        else{
            // Затем пробуем воспользоваться поиском warodai.ru
            self.search_warodai_lookup(
                corpus, 
                keyword,
                (results) => {
                    if(results.length > 0){
                        callback(results);
                    }
                    else{
                        // Если поиск не получился, делаем fallback - поиск с помощью Github
                        self.search_github(corpus, keyword,callback);
                    }
                },
                errorCallback
            );
        }
    }

    // Поиск по репозиторию github. Обладает следующими недостатками:
    // - не осущетсвляет поиск по одному символу (нельзя искать один иероглиф)
    // - ищет все подряд и без учета релевантности в терминах словаря, поэтому приходится отфильтровывать
    //   только те результаты, где искомая подстрока найдена в первой строке карточки
    // Этот поиск может использоваться как вариант fallback при отказе warodai.ru
    search_github(corpus, keyword,callback){
        var self = this;
        if(/^[\d-]+$/.test(keyword)){
            keyword = '〔'+keyword+'〕';
        }
        $.ajax({
            type: "GET",
            dataType: "json",
            crossDomain: true,
            url: self.apiGate+'/search/code?q='+encodeURI(keyword+"+in:file+repo:"+self.corpuses[corpus].repo),
            headers:{
                'Accept':'application/vnd.github.v3.text-match+json',
                "Authorization": "token "+self.access_token
            },
            success: function(data){
                var cards = []
                for(var i=0; i<data.items.length; i++){
                    if(!/^[0-9A-]+\.txt$/.test(data.items[i].name)){
                        continue;
                    }
                    itm: for(var j=0; j<data.items[i].text_matches.length; j++){
                        var fragment = data.items[i].text_matches[j].fragment;
                        var strings = fragment.split("\n");
                        for(var k=0; k<strings.length; k++){
                            if(strings[k].indexOf('〔') >= 0 && strings[k].indexOf(keyword) >= 0){
                                var match = strings[k].match(/〔([^〕]+)〕/);
                                cards.push({
                                    code: match[1],
                                    corpus: corpus,
                                    header: strings[k]
                                });
                                continue itm;
                            }
                        }
                    }
                }
                callback(cards);
            },
            error: function(){
                callback([]);
            }
        });
    }

    // Поиск с помощью поискового алгоритма warodai.ru
    // результаты полностью аналогичны поиску через warodai.ru
    search_warodai_lookup(corpus, keyword,callback){
        var self = this;
        var cards = [];
        $.ajax({
            type: "GET",
            dataType: "json",
            crossDomain: true,
            url: "https://www.warodai.ru/api/v1/corpus/lookup/?keyword="+encodeURI(keyword)+"&corpus="+corpus,
            success: function(data){
                var cards = [];
                for(var i=0; i<data.length; i++){
                    var strings = data[i].article.split("\n");
                    cards.push(
                        {
                            code: data[i].code,
                            header: strings[0],
                            corpus: corpus
                        }
                    );
                }
                callback(cards);
            },
            error: function(){
                callback([]);
            }
        });
    }

    // Поиск по копиям репозиториев, лежащих на warodai.ru
    search_warodai_repos(corpus, keyword,callback){
        var self = this;
        var cards = [];
        $.ajax({
            type: "GET",
            dataType: "json",
            crossDomain: true,
            url: "https://www.warodai.ru/api/v1/repo/lookup/?keyword="+encodeURI(keyword)+"&corpus="+corpus,
            success: function(data){
                callback(data);
            },
            error: function(){
                callback([]);
            }
        });
    }

    getCardHistory(corpus,cardCode,callback,errorCallback){
        var self = this;

        var getCommits = function(branch){
            $.ajax({
                type: "GET",
                dataType: "json",
                crossDomain: true,
                headers: {
                    "Authorization": "token "+self.access_token
                },
                data: {
                    'per_page': 100,
                    'path':self.cardCodeToPath(corpus, cardCode),
                    'sha': branch
                },
                url: self.apiGate+'/repos/'+self.corpuses[corpus].repo+'/commits',
                success: function(data){
                    var history = [];
                    $.each(data,function(){
                        history.push({
                            'versionId':this.sha,
                            'message':this.commit.message,
                            'author':this.commit.author.name,
                            'date':this.commit.author.date
                        });
                    });
                    callback(history);
                },
                error: self.getErrorDefaultCallback(errorCallback)
            });
        }
        
        self.findBranch(
            corpus,
            self.user_login+'_'+cardCode,
            function(){getCommits(self.user_login+'_'+cardCode)},
            function(){getCommits('master')}
        )
    }

    getCardVersion(corpus,cardCode,versionId,callback,errorCallback){
        var self = this;

        var getContent = function(ref){
            $.ajax({
                type: "GET",
                dataType: "json",
                crossDomain: true,
                headers: {
                    "Authorization": "token "+self.access_token
                },
                data: {
                    'ref': ref
                },
                url: self.apiGate+'/repos/'+self.corpuses[corpus].repo+'/contents/'+self.cardCodeToPath(corpus, cardCode),
                success: function(data){
                    callback(utf8.decode(base64.decode(data.content)));
                },
                error: self.getErrorDefaultCallback(errorCallback)
            });
        }

        if(versionId){
            getContent(versionId);
        }
        else{
            self.findBranch(
                corpus,
                self.user_login+'_'+cardCode,
                function(){getContent(self.user_login+'_'+cardCode);},
                function(){getContent('master');}
            );
        }
    }

    commit(corpus,isNew,writeMaster,commit,progressCallback,callback,errorCallback){
        var self = this;

        if(writeMaster){
            progressCallback(50);
            self.commitToBranch(corpus,isNew,commit,'master',progressCallback,callback,errorCallback);
            return;
        }
        
        var repo = self.corpuses[corpus].repo;

        var createBranch = function(sha, branch, success, failure){
            progressCallback(50);
            $.ajax({
                url: self.apiGate+"/repos/"+repo+'/git/refs',
                type: "POST", dataType: "json", crossDomain: true, 
                data: JSON.stringify({
                    'ref': "refs/heads/"+branch,
                    'sha': sha
                }),
                headers: {
                    "Authorization": "token "+self.access_token
                },
                success: success,
                error: failure
            });
        }

        self.findBranch(
            corpus,
            self.user_login+'_'+commit.card_code,
            function(data){
                self.commitToBranch(corpus,isNew,commit,self.user_login+'_'+commit.card_code,progressCallback,callback,errorCallback);
            },
            function(){
                self.findBranch(
                    corpus,
                    'master',
                    function(data){
                        createBranch(
                            data.object.sha, 
                            self.user_login+'_'+commit.card_code,
                            function(data){
                                self.commitToBranch(
                                    corpus,
                                    isNew,
                                    commit,
                                    self.user_login+'_'+commit.card_code,
                                    progressCallback,
                                    function(){
                                        $.ajax({
                                            url:  self.apiGate+"/repos/"+repo+'/pulls',
                                            type: "POST", dataType: "json", crossDomain: true, 
                                            data: JSON.stringify({
                                                'title': "Изменения "+commit.card_code,
                                                'head': self.user_login+'_'+commit.card_code,
                                                'base': 'master'
                                            }),
                                            headers: {
                                                "Authorization": "token "+self.access_token
                                            },
                                            success: callback,
                                            error: errorCallback
                                        });
                                    },
                                    errorCallback
                                );
                            },
                            self.getErrorDefaultCallback(errorCallback)
                        );
                    },
                    self.getErrorDefaultCallback(errorCallback)
                )
            }
        );
    }

    commitToBranch(corpus,isNew,commit,branch,progressCallback,callback,errorCallback){
        var self = this;
        var repo = self.corpuses[corpus].repo;

        var doCommit = function(sha){
            var q = {
                content: base64.encode(utf8.encode(commit.content)),
                message: commit.commit_message,
                branch: branch
            }

            if(sha) q.sha = sha;

            $.ajax({
                url: self.apiGate+"/repos/"+repo+"/contents/"+self.cardCodeToPath(corpus, commit.card_code),
                type: "PUT", 
                dataType: "json", 
                crossDomain: true,   
                data: JSON.stringify(q),      
                headers: {
                    "Authorization": "token "+self.access_token
                },                    
                success: function(data){
                    callback(data);
                },
                error: self.getErrorDefaultCallback(errorCallback)
            });
        }

        if(isNew){
            progressCallback(75);
            doCommit(null);
        }
        else{
            $.ajax({
                url: self.apiGate+"/repos/"+repo+"/contents/"+self.cardCodeToPath(corpus, commit.card_code),
                type: "GET", dataType: "json", crossDomain: true, 
                headers: {
                    "Authorization": "token "+self.access_token
                },
                data: {
                    'ref': branch
                },
                success: function(data){
                    progressCallback(75);
                    doCommit(data.sha);
                },
                error: self.getErrorDefaultCallback(errorCallback)
            });
        }
    }

    findBranch(corpus, branch, success, failure){
        var self = this;
        $.ajax({
            url: self.apiGate+"/repos/"+self.corpuses[corpus].repo+'/git/ref/heads/'+branch,
            type: "GET", dataType: "json", crossDomain: true, 
            headers: {
                "Authorization": "token "+self.access_token
            },
            success: success,
            error: failure
        });
    }

    getNextCardNumber(corpus, callback, errorCallback){
        var self = this;
        var repo = self.corpuses[corpus].repo;

        var findMaxPath = (sha, clbk) => {
            $.ajax({
                url: self.apiGate+"/repos/"+repo+"/git/trees/"+sha,
                type: "GET",
                dataType: "json",
                crossDomain: true, 
                headers: {
                    "Authorization": "token "+self.access_token
                }, 
                success: (data) => {
                    var max = {path: ''};
                    for(var i=0; i<data.tree.length; i++){
                        if(/^[0-9-]+(\.txt)?$/.test(data.tree[i].path) && data.tree[i].path > max.path){
                            max = data.tree[i];
                        }
                    }
                    if(max.type == 'tree'){
                        findMaxPath(max.sha, clbk);
                    }
                    else{
                        clbk(max);
                    }
                },
                error: self.getErrorDefaultCallback(errorCallback)
            })
        }

        var findMaxBranch = (clbk) => {
            $.ajax({
                url: self.apiGate+"/repos/"+repo+"/branches",
                type: "GET",
                dataType: "json",
                crossDomain: true, 
                headers: {
                    "Authorization": "token "+self.access_token
                }, 
                success: (data) => {
                    var max = 0;
                    for(var i=0; i<data.length; i++){
                        var match = data[i].name.match(/[0-9-]+$/);
                        if(match){
                            var m = parseInt(match[0].replace(/-/g,''));
                            if(m > max){
                                max = m;
                            }
                        }
                    }
                    clbk(max);
                },
                error: self.getErrorDefaultCallback(errorCallback)
            })
        }

        $.ajax({
            url: self.apiGate+"/repos/"+repo+"/branches/master",
            dataType: "json", crossDomain: true,
            headers: {
                "Authorization": "token "+self.access_token
            }, 
            success: function(data){
                var tree_sha = data.commit.commit.tree.sha;
                findMaxPath(tree_sha, (max)=>{
                    var last_card = max.path;
                    last_card = parseInt(last_card.replace(/^0+/,'').replace(/-/g,'').replace(/\.txt/, ''));
                    if(Number.isNaN(last_card)){
                        errorCallback('код "'+last_card+'" не является числовым');
                        return;
                    }

                    findMaxBranch(function(max){
                        if(max > last_card){
                            last_card = max;
                        }
                        var next_card = last_card+1;
                        next_card = next_card+"";
                        var struct = self.corpuses[corpus].codeStructure;
                        var next_card_array = new Array(struct.length);
                        var next_card_char_counter = next_card.length - 1;
                        for(var i=struct.length-1; i >= 0; i--){
                            var c = struct[i];
                            if(c == '0'){
                                if(next_card_char_counter >= 0){
                                    next_card_array[i] = next_card[next_card_char_counter];
                                    next_card_char_counter--;
                                }
                                else{
                                    next_card_array[i] = '0';
                                }
                            }
                            else if(c == '-' || c == '/'){
                                next_card_array[i] = '-';
                            }
                        }
                        callback(next_card_array.join(''));
                    });
                });
            },
            error: self.getErrorDefaultCallback(errorCallback)
        });
       
    }

    cardCodeToPath(corpus, cardCode, type='codeStructure', ext='.txt'){
        var codeStructure = this.corpuses[corpus][type];
        var structReg = new RegExp('('+codeStructure.replace(/0+/g,'\[0-9A-Z]+').replace(/\//g,')-(')+')');
        var match = cardCode.match(structReg);
        if(match && match.length >= 3){
            var path = [];
            for(var i=1; i<match.length-1; i++){
                path.push(match[i]);
            }
            
            return path.join('/')+'/'+cardCode+ext;
        }
        
    }

    getCardImgURL(corpus, cardCode, callback,errorCallback){
        var p = this.cardCodeToPath(corpus, cardCode, 'imageCodeStructure', '.png')
        var self = this;
        $.ajax({
            url: self.apiGate+"/repos/"+this.corpuses[corpus].imagesRepo+"/contents/"+p,
            type: "GET",
            data: {
                'ref': "master"
            },
            headers: {
                "Authorization": "token "+self.access_token
            }, 
            success: (data) => {
                callback('data:image/png;base64,'+data.content);
            },
            error: self.getErrorDefaultCallback(errorCallback)
        });
    }

    getErrorDefaultCallback(errorCallback){
        return function(jqXHR, textStatus, errorThrown){
            errorCallback(errorThrown ? errorThrown : textStatus);
        }
    }
}

export default GithubGate;